import { DashboardTypes} from "../constants/action-type";

export const setDashboard = (dashoboard_data)=>{
    return {
        type: DashboardTypes.DASHBOARD_DATA,
        payload: dashoboard_data
    }
}

